/** Analytics dashboard date-range preset chips (IST-aligned on the server). */

export const DATE_RANGE_PRESETS = [
  { id: 'today', label: 'Today' },
  { id: 'yesterday', label: 'Yesterday' },
  { id: 'week', label: 'This week' },
  { id: 'month', label: 'This month' },
  { id: 'custom', label: 'Custom dates' },
];

/**
 * Human-readable label for a custom date range picker.
 * @param {Date | null | undefined} from
 * @param {Date | null | undefined} to
 * @returns {string}
 */
export function formatCustomPeriodLabel(from, to) {
  if (!from || !to) return 'Custom range';
  const fmt = (d) =>
    d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
  return `${fmt(from)} – ${fmt(to)}`;
}
